// extracted by mini-css-extract-plugin
export default {"modalContent":"NotificationModal_modalContent__N1kwY","title":"NotificationModal_title__Ie-89","message":"NotificationModal_message__GbxKV"};